import {getFirstFulfilledInSequence} from '@yourcoach/async-utils';

import type {CourseApiModel} from '../../../api/course';
import type {MembershipApiModel} from '../../../api/membership';
import type {Expand} from '../../../api/types';
import type {CoreCoachCoursesReadParams} from '../../../api/types/core/methods';
import type {Nullable} from '../../../utils/utility-types';
import type {AsyncStrategy, BaseConfig} from '../utils';

import {courseStore} from '../../../api/course';
import {isIamCoach} from '../../../utils/entity/isIamCoach';
import {membershipFetchList} from '../membership/membership.fetch-list';

export {courseFetch};

type Config = BaseConfig<CoreCoachCoursesReadParams>;

const strategy: AsyncStrategy = async (roles, config) => {
  return isIamCoach()
    ? getFirstFulfilledInSequence([roles.coach, roles.client], config)
    : roles.client(config);
};

async function courseFetch(config: Config) {
  return strategy({client: asClient, coach: asCoach}, config);
}

courseFetch.asClient = asClient;
courseFetch.asCoach = asCoach;

async function asClient(config: Config): Promise<Nullable<CourseApiModel>> {
  const expand: Expand = {
    membership: [['course_id', null, config.params.expand ?? {}]],
  };
  const myMemberships = (await membershipFetchList.asClient({
    params: {course_id: config.params._id, expand},
  })) as (MembershipApiModel & {
    course: Nullable<CourseApiModel>;
  })[];

  if (myMemberships?.length > 0) {
    return myMemberships[0]!.course as Nullable<CourseApiModel>;
  }

  return null;
}

async function asCoach(config: Config) {
  return courseStore.fetch(config.params);
}
